import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import ValuationChartContainer from 'legacy/containers/similar-properties-chart-button';
import NearbyPropertiesSectionContainer from 'legacy/containers/nearby-chart-button';
import MarketAnalysisSectionContainer from 'legacy/containers/market-analysis-chart-button';
import ForecastSection from 'legacy/containers/forecast-chart-button';
import { getIsEffectiveDateReport } from 'selectors/property-explorer';
import { PropertyExplorerCharts as theme } from 'legacy/css-modules';

const PropertyExplorerCharts = ({ isMobile }) => {
  const isEffectiveDateReport = useSelector(getIsEffectiveDateReport);
  return (
    <Fragment>
      <h2>Explore Insights</h2>
      <div className={theme.ChartsContainer}>
        {!isMobile && <ValuationChartContainer />}
        {!isEffectiveDateReport && <ForecastSection />}
        <NearbyPropertiesSectionContainer />
        {!isEffectiveDateReport && <MarketAnalysisSectionContainer />}
      </div>
    </Fragment>
  );
};

export default PropertyExplorerCharts;
